import { useEffect, useCallback } from 'react';

import { getCardTransactions } from '@/store/actions/card-transactions.actions';
import { Page } from '@/ui-kit/templates/Page';
import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';
import { CardTransactionsTable } from '@/features/cards/components/CardTransactionsTable/CardTransactionsTable';
import { ColumnsProvider } from '@/features/cards/context/CardTransactionColumnContext';
import { allColumnConfig } from '@/features/cards/store/models/card-transactions.model';

export function AllCardTransactions() {
  const dispatch = useAppDispatch();

  const cardTransactions = useAppSelector((state) => state.cardTransactions.paginateCardTransactions?.elements);
  const isCardTransactionsLoading = useAppSelector((state) => state.cardTransactions.isLoading);
  const cursor = useAppSelector((state) => state.cardTransactions.paginateCardTransactions?.cursor);

  useEffect(() => {
    dispatch(getCardTransactions());
  }, [dispatch]);

  const handleChangeFilter = useCallback(
    ({ filters, cursorId }) => {
      dispatch(getCardTransactions(filters, cursorId));
    },
    [dispatch],
  );

  return (
    <Page>
      <ColumnsProvider initialConfig={allColumnConfig} isAllTransactions>
        <CardTransactionsTable
          cardTransactions={cardTransactions}
          cursor={cursor}
          onFiltersChange={handleChangeFilter}
          isLoadingTransactions={!!isCardTransactionsLoading}
        />
      </ColumnsProvider>
    </Page>
  );
}
